import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "aspect-product-gallery" }
const _hoisted_2 = { class: "mt-12 mb-16 h-fit" }
const _hoisted_3 = {
  key: 0,
  class: "h6 tablet:h5 mb-4"
}
const _hoisted_4 = {
  key: 1,
  class: "my-4 text-14"
}
const _hoisted_5 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_grid_item_tags = _resolveComponent("grid-item-tags")
  const _component_product_picker_quick_view_gallery = _resolveComponent("product-picker-quick-view-gallery")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_component_product_picker_quick_view_gallery, {
        key: $props.product.media[0].src,
        media: $props.product.media,
        "first-image-index": $props.product.quick_view_first_image_index,
        "show-arrows": true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_grid_item_tags, {
            class: "badge-large text-16",
            margin: 'large',
            product: {
            available: $props.product.available,
            title: $props.product.title,
            price: $props.product.price,
            compare_at_price: $props.product.compare_at_price,
            tags: $props.product.tags,
          }
          }, null, 8, ["product"])
        ]),
        _: 1
      }, 8, ["media", "first-image-index"]))
    ]),
    _createElementVNode("div", _hoisted_2, [
      ($props.product.title)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString($props.product.title), 1))
        : _createCommentVNode("", true),
      ($props.product.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($props.product.description), 1))
        : _createCommentVNode("", true),
      ($props.showStarRating && $props.product.stamped_badge)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            innerHTML: $props.product.stamped_badge
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      class: "btn btn-primary btn-plus__before btn-plus--large mt-24 w-full py-8 text-18 capitalize",
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('isClicked')))
    }, _toDisplayString($data.locale.quick_view_button_label), 1)
  ]))
}